<template>
  <section class="w-full">
    <h1 class="flex items-center justify-between">
      {{ $t('components.company.billing.title') }}
      <div class="text-sm text-gray-600">
        <button
          class="font-semibold uppercase hover:text-gray-800"
          @click="showCompanyBillingEditModal()"
        >
          <fa :icon="faPen" />
          {{ $t('components.company.billing.edit') }}
        </button>
      </div>
    </h1>

    <div class="flex flex-wrap w-full">
      <div class="flex-col w-full mb-2 lg:w-1/2">
        <data-field
          :label="$t('components.company.billing.vatId')"
          required
          :has-value="Boolean(company.billing.vatId || company.billing.vatIdRequestDate)"
        >
          {{ company.billing.vatId ?
            company.billing.vatId :
            company.billing.vatIdRequestDate && $t('components.company.billing.vatIdRequestedAt') + formatDate(company.billing.vatIdRequestDate) }}
        </data-field>
        <data-field
          :label="$t('components.company.billing.taxNumber')"
          required
          :has-value="Boolean(company.billing.taxNumber)"
        >
          {{ company.billing.taxNumber }}
        </data-field>
        <data-field
          :label="$t('components.company.billing.paymentMethod')"
          required
          :has-value="Boolean(company.billing.paymentMethod)"
        >
          {{ getPaymentMethodsName(company.billing.paymentMethod) }}
        </data-field>
      </div>
      <div class="flex-col w-full mb-2 lg:w-1/2">
        <data-field
          :label="$t('components.company.billing.bic')"
          :value="company.billing.bic"
        />
        <data-field
          :label="$t('components.company.billing.iban')"
          :value="company.billing.iban"
        />
        <data-field
          :label="$t('components.company.billing.sepaValidAsOf')"
          :value="formatDate(company.billing.sepaValidAsOf)"
        />
      </div>
      <div class="flex-col w-full mb-2 lg:w-1/2">
        <data-field :label="$t('components.company.billing.companyName')">
          {{ company.billing.contact.companyName }}
        </data-field>
        <data-field :label="$t('components.company.billing.companyNameAddition')">
          {{ company.billing.contact.companyNameAddition }}
        </data-field>
        <data-field
          :label="$t('components.company.billing.firstname')"
          required
          :value="company.billing.contact.firstname"
        />
        <data-field
          :label="$t('components.company.billing.lastname')"
          required
          :value="company.billing.contact.lastname"
        />
        <data-field
          :label="$t('components.company.billing.email')"
          required
          :value="company.billing.contact.email"
        />
        <data-field
          :label="$t('components.company.billing.phone')"
          required
          :value="company.billing.contact.phone"
        />
      </div>
      <div class="flex-col w-full mb-2 lg:w-1/2">
        <h2 class="flex items-center w-full my-4 font-medium uppercase border-b-2">
          <input
            v-model="company.billing.hasSeparateBillingAddress"
            type="checkbox"
            disabled
            class="w-4 h-4 mr-2 border-2 border-gray-600 form-checkbox"
            :value="company.billing.hasSeparateBillingAddress || false"
          >
          {{ $t('components.company.billing.separateBillingAddress') }}
        </h2>
        <data-field :label="$t('components.company.billing.street')">
          {{ company.billing.address.street }}
        </data-field>
        <data-field :label="$t('components.company.billing.zip')">
          {{ company.billing.address.zip }}
        </data-field>
        <data-field :label="$t('components.company.billing.city')">
          {{ company.billing.address.city }}
        </data-field>
      </div>
    </div>
  </section>
</template>

<script>
import EditCompanyBillingModal from '@/components/modals/company/billing/edit'
import DataField from '@/components/data-field'
import { faPen } from '@fortawesome/free-solid-svg-icons'
import { getPaymentMethodsName } from '@/config'

import GET_COMPANY_BILLING from '@/graphql/GetCompanyBilling.gql'

export default {
  components: { DataField },
  props: {
    companyId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      faPen,
      company: {
        billing: {
          contact: {},
          address: {}
        }
      }
    }
  },
  apollo: {
    company: {
      query: GET_COMPANY_BILLING,
      variables () {
        return { id: this.companyId }
      },
      update (data) {
        data.company.billing = data.company.billing || {}
        const { billing, address } = data.company
        const { street, zip, city } = address || {}
        billing.contact = billing.contact || {}
        billing.address = billing.hasSeparateBillingAddress
          ? billing.address || {}
          : { street, zip, city }
        return data.company
      }
    }
  },
  methods: {
    getPaymentMethodsName (value) {
      // eslint-disable-next-line no-void
      void this.$i18n.locale
      return getPaymentMethodsName(value)
    },
    showCompanyBillingEditModal () {
      this.$modal.show(
        EditCompanyBillingModal,
        {
          company: {
            ...this.company,
            billing: {
              ...this.company.billing,
              contact: { ...this.company.billing.contact },
              address: { ...this.company.billing.address }
            }
          }
        }
      )
    }
  }
}
</script>
